import {Base} from "@/api/Base"

export class AttendanceAdd extends Base {
    path = "attendance/add"
}